import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter } from 'react-router-dom';
import './index.css';
import App, { appRoutes } from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const router = createBrowserRouter(appRoutes);
const app = (
  <React.StrictMode>
    <App router={router} />
  </React.StrictMode>
);

if (container.firstElementChild) {
  // `npm run build` prerenders every route into #root: attach to that markup.
  ReactDOM.hydrateRoot(container, app, {
    onRecoverableError(error) {
      // Hydration mismatches land here (React then re-renders on the client).
      console.error('[hydration]', error);
    },
  });
} else {
  // `npm start` (CRA dev server) serves an empty #root.
  ReactDOM.createRoot(container).render(app);
}

reportWebVitals();
